import { render, staticRenderFns } from "./sub3Page.vue?vue&type=template&id=47188188&scoped=true"
import script from "./sub3Page.vue?vue&type=script&lang=js"
export * from "./sub3Page.vue?vue&type=script&lang=js"
import style0 from "./sub3Page.vue?vue&type=style&index=0&id=47188188&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47188188",
  null
  
)

export default component.exports